import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper = new Swiper(".section2 .left-swiper .mySwiper", {
  effect : 'fade',
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  autoHeight: true,
  navigation: {
    nextEl: ".section2 .swiper-button-next",
    prevEl: ".section2 .swiper-button-prev",
  },
  breakpoints: {
    1025: {
      autoHeight: false,
    },
  },
});

var swiper2 = new Swiper(".section2 .desc .mySwiper", {
  effect : 'fade',
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  autoHeight: true,
  navigation: {
    nextEl: ".section2 .swiper-button-next",
    prevEl: ".section2 .swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
  breakpoints: {
    1025: {
      autoHeight: false,
    },
  },
});